
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/reset.css"
Vue.config.productionTip = false

import axios from 'axios';
Vue.prototype.$akax=axios;
import VueTouch from "vue-touch";
Vue.use(VueTouch, {name: "v-touch"});
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js